import { useCallback, useState } from 'react';
import { handleRealUsedFlag } from '@bingads-webui-campaign-react/asset-library-model';

export const useVideoDurationFilter = ({
  logger,
  preference,
  realUsedFlagSuffix,
}) => {
  const [minDurationFilter, setMinDurationFilter] = useState(null);
  const [maxDurationFilter, setMaxDurationFilter] = useState(null);

  const onVideoDurationFilterChange = useCallback(({ newMinDuration, newMaxDuration }) => {
    if (newMinDuration !== minDurationFilter) {
      logger.logTrace('onVideoDurationFilterChange', { minDuration: newMinDuration });
      setMinDurationFilter(newMinDuration);
      handleRealUsedFlag(preference, realUsedFlagSuffix);
    }
    if (newMaxDuration !== maxDurationFilter) {
      logger.logTrace('onVideoDurationFilterChange', { maxDuration: newMaxDuration });
      setMaxDurationFilter(newMaxDuration);
      handleRealUsedFlag(preference, realUsedFlagSuffix);
    }
  }, [logger, maxDurationFilter, minDurationFilter, preference, realUsedFlagSuffix]);

  return {
    minDurationFilter,
    maxDurationFilter,
    onVideoDurationFilterChange,
  };
};
